import React, { useState } from 'react';
import { Button, PaginationTable, Table, TableWrapper } from 'components/Global';
import EmptyState from 'components/Global/EmptyState';

import { ReactComponent as PlusIcon } from 'icons/plus-icon.svg';
import { ReactComponent as OneDayBookingIcon } from 'icons/one-day-booking-filled-icon.svg';
import LoadingSpinner from 'components/Global/LoadingSpinner';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { deleteOneDayBooking, getAllOneDayBooking } from 'features/one-day-booking-surcharge/actions';
import { checkEmptyObject, setCurrency } from 'utils/functionality';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from 'components/Context/AppContext';
import { trackEvent } from 'utils/analytics';

const column = [
  { header: 'No.', value: 'no' },
  { header: 'Lokasi', value: 'location_one_day_booking' },
  { header: 'Kategori Mobil', value: 'vehicle_category_one_day_booking' },
  { header: 'Charge Tambahan', value: 'fee_amount' },
];

const TableComponent = ({ data, currentPage, setCurrentPage, onDel, onEdit, onDetail }) => {
  const { data: oneDayBookingData, isLoading } = useSelector((state) => state.oneDayBooking);

  if (isLoading) {
    return <LoadingSpinner />;
  } else if (data && data.length > 0 && !isLoading) {
    return (
      <>
        <Table column={column} data={data} actionBtn onDel={onDel} onEdit={onEdit} onDetail={onDetail} />
        <PaginationTable
          currentPage={currentPage}
          onPageChange={(newPage) => setCurrentPage(newPage)}
          totalCount={oneDayBookingData?.pagination?.total}
        />
      </>
    );
  } else if ((!data || data.length === 0) && !isLoading) {
    return <EmptyState />;
  }
};

const OneDayBookingSurchargeComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { setShowConfirmation, showToast } = useAppContext();

  const { data: oneDayBookingData } = useSelector((state) => state.oneDayBooking);

  const [currentPage, setCurrentPage] = useState(1);
  const [newData, setNewData] = useState([]);

  const addoneDayBookingHandler = () => {
    navigate('/one-day-booking-surcharge/add-item');
  };

  const deleteOneDayBookingHandler = (e) => {
    const oneDayBookingId = e.target.parentElement.parentElement.dataset['key'];

    setShowConfirmation({
      show: true,
      message: 'Apakah anda yakin ingin menghapus One Day Booking Surcharges?',
      onClick: async () => {
        try {
          trackEvent('one_day_booking_surcharge_deleted', {
            id: oneDayBookingId,
            source: 'one_day_booking_surcharge_list',
          });
          await dispatch(deleteOneDayBooking(oneDayBookingId)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Hapus One Day Booking Surcharges' });
          dispatch(getAllOneDayBooking({ page: currentPage, limit: 10 }));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error);
          showToast({ type: 'error', message: `${error.message}` });
        }
      },
    });
  };

  const detailOneDayBookingHandler = (e) => {
    const oneDayBookingId = e.target.parentElement.parentElement.dataset['key'];
    navigate(`/one-day-booking-surcharge/detail?id=${oneDayBookingId}`);
  };

  const editOneDayBookingHandler = (e) => {
    const oneDayBookingId = e.target.parentElement.parentElement.dataset['key'];
    navigate(`/one-day-booking-surcharge/edit?id=${oneDayBookingId}`);
  };

  useEffect(() => {
    dispatch(getAllOneDayBooking({ limit: 10, page: currentPage }));
  }, []);

  useEffect(() => {
    if (!oneDayBookingData || checkEmptyObject(oneDayBookingData)) return;

    const newOneDayBookingData = oneDayBookingData.data.map((item) => ({
      ...item,
      fee_amount: setCurrency(item.fee_amount).replace('Rp', item.locations[0].currency),
      location_one_day_booking: item.locations,
      vehicle_category_one_day_booking: item.categories,
    }));
    setNewData(newOneDayBookingData);
  }, [oneDayBookingData]);

  return (
    <div className="one-day-booking">
      <div className="one-day-booking__button">
        <Button width="192px" height="39px" className="button-add" onClick={addoneDayBookingHandler}>
          <PlusIcon />
          <span className="button-label">Tambah</span>
        </Button>
      </div>

      <TableWrapper
        title="One-Day Booking Surcharge"
        icon={<OneDayBookingIcon fill="#009EF7" width="25px" height="25px" />}
        style={{ minHeight: '100vh' }}
      >
        <TableComponent
          data={newData}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onDel={deleteOneDayBookingHandler}
          onEdit={editOneDayBookingHandler}
          onDetail={detailOneDayBookingHandler}
        />
      </TableWrapper>
    </div>
  );
};

export default OneDayBookingSurchargeComponent;
